import { useQuery } from '@tanstack/react-query';
import { getMakerForward } from '../lib/apiClient';

// The scorer runs every five minutes; a round settles every fifteen.
const STALE_TIME_MS = 2 * 60_000;

/** Forward paper test of BTC 15m market making. Hypothetical only. */
export function useMakerForward() {
  return useQuery({
    queryKey: ['btc15-maker-forward'],
    queryFn: getMakerForward,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
